export class Emitter {
    constructor() {
        this.events = Object.create(null);
    }
    on(event, handler) {
        (this.events[event] || (this.events[event] = [])).push(handler);
    }
    off(event, handler) {
        if (!this.events[event])
            return;
        this.events[event].splice(this.events[event].indexOf(handler) >>> 0, 1);
    }
    emit(event, data) {
        (this.events[event] || []).forEach((handler) => {
            handler(data);
        });
    }
}
